var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{attrs:{"title":"Account Information","step-component":'AccountInformationStep'}},[_c('AccountIdCardContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }